import { createElement } from "../DOMutils";

class Toaster {
    constructor() {
        if (Toaster._instance) {
            return Toaster._instance;
        }
        Toaster._instance = this;
        this.toasts = {};
        this.el = this.createToasterEl();
    }

    createToasterEl() {
        const el = createElement("div", { class: "toaster" });
        document.body.appendChild(el);

        return el;
    }

    createToast(id, text, iconUnicode = null, persistent = false) {
        const toast = { id };
        const toastEl = createElement("div", { class: `toast ${persistent ? "toast--persistent" : ""}` });
        const textEl = createElement("p", {}, text);
        const closeButtonEl = createElement("button", {
            type: "button",
            class: "toast__close cross",
            "aria-label": "Close",
        });

        if (iconUnicode) {
            const iconEl = createElement("span", { class: "unicode-icon" }, iconUnicode);
            toastEl.appendChild(iconEl);
        }

        toastEl.appendChild(textEl);
        toastEl.appendChild(closeButtonEl);

        toast["el"] = toastEl;

        closeButtonEl.addEventListener("click", this.handleCloseClick.bind(null, toast));
        toastEl.addEventListener("animationend", this.handleAnimationEnd.bind(this, toast));

        return toast;
    }

    addToast(toast) {
        if (this.toasts[toast.id]) return;

        this.toasts[toast.id] = toast.el;
        this.el.prepend(toast.el);
    }

    renderToast(toast, delay = null) {
        if (!delay) this.addToast(toast);

        setTimeout(() => this.addToast(toast), delay);
    }

    handleCloseClick(toast) {
        toast.el.style.animation = "fadeOutTop 1 0.4s";
    }

    handleAnimationEnd(toast, e) {
        if (e.animationName === "fadeInTop") return;

        toast.el.remove();
        delete this.toasts[toast.id];
    }
}

export default new Toaster();
